import { render, staticRenderFns } from "./EmulatorColorModeSelector.vue?vue&type=template&id=211e934e&scoped=true"
import script from "./EmulatorColorModeSelector.vue?vue&type=script&lang=js"
export * from "./EmulatorColorModeSelector.vue?vue&type=script&lang=js"
import style0 from "./EmulatorColorModeSelector.vue?vue&type=style&index=0&id=211e934e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211e934e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('211e934e')) {
      api.createRecord('211e934e', component.options)
    } else {
      api.reload('211e934e', component.options)
    }
    module.hot.accept("./EmulatorColorModeSelector.vue?vue&type=template&id=211e934e&scoped=true", function () {
      api.rerender('211e934e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Emulator/EmulatorColorModeSelector.vue"
export default component.exports